import React from "react";

const NotFound = () => {
  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-6">
          <div className="alert alert-warning text-center">
            <h1>
              <i className="fas fa-question-circle fa-2x mb-3"></i>
            </h1>
            <h4>Page Not Found</h4>
            <p>The page you're looking for doesn't exist.</p>
            <button
              className="btn btn-primary"
              onClick={() => (window.location.href = "/")}
            >
              Go to Dashboard
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
